import React from 'react'
import type { RetorikMainComponentProps } from '../models/retorikTypes'
import ShadowRoot from './Common/ShadowRoot'
import RetorikContainer from './Common/RetorikContainer'
import { ContainerParent } from '../models/enums'

const RetorikNews = (props: RetorikMainComponentProps): JSX.Element => {
  // --------- /!\ -----------
  // Ne mettre ici que de la logique spécifique au retorikNews
  // Ce qui est commun avec RetorikWidget ou autres doit aller dans RetorikComposer ou ContextProvider
  // -------------------------

  return (
    <ShadowRoot>
      <RetorikContainer {...{ parent: ContainerParent.news, ...props }} />
    </ShadowRoot>
  )
}

export default RetorikNews
